/* eslint-disable prettier/prettier */ /* eslint-disable no-nested-ternary */ /* eslint-disable no-unused-vars */ /* eslint-disable no-promise-executor-return */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/prop-types */ import React, {  useState,
  useRef,
  useContext,
} from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import Chip from '@material-ui/core/Chip';
import _ from 'lodash';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import locale from 'date-fns/locale/pt-BR';
import DateFnsUtils from '@date-io/date-fns';

import { TextField, Grid, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone';
import AddIcon from '@material-ui/icons/Add';
import FlashContext from '../../../../components/contexts/FlashContext';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: 10,
    margin: 0,
  },
  chip: {
    margin: 10,
  },
  myTextField: {
    backgroundColor: 'none',
    boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
    border: 'none',
    color: '#717171',
    fontWeight: 'bold',
    fontFamily: 'Open Sans',
  },
  text: {
    fontFamily: 'Open Sans',
    fontWeight: 'bold',
    color: '#717171',
  },
  input: {
    backgroundColor: '#fff',
    marginTop: 0,
  },
}));

function BalanceFilter({ chipData, setChipData, find, setPage }) {
  const { t } = useTranslation();
  const local = useLocation();
  const [searchType, setSearchType] = useState();
  const { notifyError } = useContext(FlashContext);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const classes = useStyles();
  const searchRef = useRef(null);

  const handleDelete = chipToDelete => () => {
    setOptions([
      ...options,
      { label: chipToDelete.by, value: chipToDelete.byType },
    ]);
    setChipData(chips => chips.filter(chip => chip.key !== chipToDelete.key));
  };

  const internSearch = () => {
    if (searchType?.valeu !== '' && searchRef?.current?.value !== '') {
      includeSearch(true);
    } else {
      setPage(0);
      find();
    }
  };

  const [options, setOptions] = useState([
    {
      label: 'CNPJ',
      value: 'companyCnpj',
    },
    {
      label: 'Cliente',
      value: 'companyName',
    },
    {
      label: 'Data referência',
      value: 'date',
    },
    {
      label: 'Pedido',
      value: 'orderNumber',
    },
  ]);

  const includeSearch = btn => {
    try {
      const orig = _.cloneDeep(options);

      const newChip = {
        key: chipData.length + 1,
        label:
          searchType.value === 'date'
            ? `${moment(startDate).format('DD/MM/YYYY')} - ${moment(
                endDate,
              ).format('DD/MM/YYYY')}`
            : searchRef?.current?.value.trim(),
        by: searchType.label,
        byType: searchType.value,
        startDate,
        endDate,
      };
      const updatedChips = [...chipData, newChip];

      setChipData(updatedChips);
      setPage(0);

      const myfind = orig.findIndex(e => e.value === searchType.value);
      orig.splice(myfind, 1);
      setSearchType(null);
      setOptions(orig);

      if (btn) {
        find(updatedChips);
      }

      if (searchRef.current) {
        searchRef.current.value = '';
      }
    } catch (e) {
      notifyError('Escolha um Tipo');
    }
  };

  const addChip = () => {
    if (searchType) {
      includeSearch(false);
    } else {
      notifyError(t('contract.filters.typeSearchMsg'));
    }
  };

  const teclaEnter = e => {
    if (e.key === 'Enter') {
      internSearch();
    }
  };

  return (
    <>
      <Grid
        container
        style={{
          justifyContent: 'end',
          alignItems: 'center',
          marginBottom: 30,
          marginTop: 15,
        }}
      >
        <Grid item xs={12} sm={3} />
        <Grid item xs={12} sm={9}>
          <Grid
            container
            spacing={1}
            style={{
              display: 'flex',
              justifyContent: 'end',
              alignItems: 'end',
            }}
          >
            <Grid item style={{ display: 'flex', alignItems: 'end' }}>
              <Select
                fullWidth
                onChange={setSearchType}
                value={searchType}
                classNamePrefix="select"
                placeholder={t('contract.filters.type')}
                isSearchable={false}
                options={options}
                menuPortalTarget={document.body}
                style={{ zIndex: 999 }}
              />
            </Grid>
            <Grid
              item
              style={{
                display: 'flex',
                justifyContent: 'end',
                alignItems: 'end',
              }}
            >
              {searchType?.value === 'date' ? (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '5px',
                  }}
                >
                  <div>
                    <h6>Data início</h6>
                    <MuiPickersUtilsProvider
                      locale={locale}
                      utils={DateFnsUtils}
                      style={{ float: 'right ' }}
                    >
                      <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        maxDate={endDate || new Date()}
                        inputVariant="outlined"
                        // style={{ backgroundColor: '#fff' }}
                        size="small"
                        format="dd/MM/yyyy"
                        InputProps={{ readOnly: true }}
                        InputAdornmentProps={{ position: 'start' }}
                        value={startDate}
                        onChange={date => {
                          setStartDate(date);
                          setPage(0);
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div>
                    <h6>Data fim</h6>
                    <MuiPickersUtilsProvider
                      locale={locale}
                      utils={DateFnsUtils}
                      style={{ float: 'right ' }}
                    >
                      <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        minDate={startDate}
                        maxDate={new Date()}
                        inputVariant="outlined"
                        // style={{ backgroundColor: '#fff' }}
                        size="small"
                        format="dd/MM/yyyy"
                        InputProps={{ readOnly: true }}
                        InputAdornmentProps={{ position: 'start' }}
                        value={endDate}
                        onChange={date => {
                          setEndDate(date);
                          setPage(0);
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              ) : (
                <TextField
                  onKeyUpCapture={e => teclaEnter(e)}
                  inputRef={searchRef}
                  color="secondary"
                  width="400px"
                  className={classes.textField}
                  fullWidth
                  size="small"
                  style={{
                    minWidth: 300,
                  }}
                  variant="outlined"
                  InputProps={{
                    className: classes.input,
                  }}
                />
              )}
              <Button
                onClick={addChip}
                variant="contained"
                style={{ marginLeft: 5, marginRight: 5 }}
              >
                <AddIcon />
              </Button>
              <Button onClick={internSearch} variant="contained">
                {t('contract.filters.btnSearch')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={4} sm={6}>
        <Grid item className={classes.root}>
          {chipData.map((dt, i) => {
            let icon;
            return (
              // eslint-disable-next-line react/no-array-index-key
              <li key={i}>
                <Chip
                  icon={icon}
                  label={`${dt.by} | ${dt.label}`}
                  onDelete={handleDelete(dt)}
                  className={classes.chip}
                />
              </li>
            );
          })}
        </Grid>
      </Grid>
    </>
  );
}

export default BalanceFilter;
